<template>
  <div
    class="cb-modal"
    :class="{ 'cb-modal--centered-on-mobile': centeredOnMobile }"
    role="dialog"
    aria-labelledby="dialog-title"
  >
    <div class="cb-modal__content">
      <component :is="modalContent" v-bind="props"></component>
    </div>
  </div>
</template>

<script>
/* global gtag */
import { mapActions, mapState } from 'vuex';
import Troubleshoot from './Troubleshoot.vue';
import ErrorContent from './modal_content/Error.vue';
import ForgotPassword from './modal_content/ForgotPassword.vue';
import AccountLocked from './modal_content/AccountLocked.vue';
import SessionTimeout from './modal_content/SessionTimeout.vue';
import Auth from './modal_content/Auth.vue';

export default {
  computed: {
    props() {
      if (this.modalContent === 'cbTroubleshoot') {
        return { title: true };
      }
      return {};
    },
    ...mapState({
      modalContent: (state) => state.modal.modalContent,
      closableOnEscapeKey: (state) => state.modal.closableOnEscapeKey,
      centeredOnMobile: (state) => state.modal.centeredOnMobile,
    }),
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscapeKeyPress);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscapeKeyPress);
  },
  methods: {
    handleEscapeKeyPress(e) {
      if (e.keyCode === 27 && this.closableOnEscapeKey) {
        this.closeModal();
        gtag('event', 'closeModalKeypress', {
          event_label: 'close',
          event_category: 'modal',
          value: 1,
        });
      }
    },
    ...mapActions(['closeModal']),
  },
  watch: {
    $route() {
      this.closeModal();
    },
  },
  components: {
    cbTroubleshoot: Troubleshoot,
    cbError: ErrorContent,
    cbForgotPassword: ForgotPassword,
    cbAccountLocked: AccountLocked,
    cbSessionTimeout: SessionTimeout,
    cbAuth: Auth,
  },
};
</script>

<style lang="scss" scoped>
.cb-modal {
  position: absolute;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;

  &__content {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    margin: 20px 0;
    z-index: 1000;
    border-radius: 10px;
    background-color: white;
  }

  &--centered-on-mobile {
    .cb-modal__content {
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: 0;
    }
  }

  @include desktop {
    &__content {
      width: auto;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: 0;
    }
  }
}
</style>
